import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Kit después de comprar?',
  a: 'Al instante. Recibirás un correo con el acceso directo para descargar los 3 Tomos en PDF de alta calidad, más los enlaces a tus plantillas y bonos.'
}, {
  q: '¿Sirve si recién empiezo o es solo para avanzados?',
  a: 'El Tomo 1 construye desde los cimientos biomecánicos, ideal si tienes malas mañas. El Tomo 2 y 3 escalan rápidamente hacia el nivel competitivo. Es un camino de progresión.'
}, {
  q: '¿Necesito un robot o me alcanza con un compañero?',
  a: 'El 90% del sistema está diseñado para ser ejecutado con un compañero de entrenamiento (bloqueador) en cualquier mesa estándar.'
}, {
  q: '¿La Guía de Materiales recomienda marcas caras?',
  a: 'No. Te enseña a leer las especificaciones para que puedas elegir inteligentemente entre opciones premium (europeas) o alternativas asiáticas de alto rendimiento según tu presupuesto.'
}, {
  q: '¿Qué diferencia tiene con tutoriales gratis en YouTube?',
  a: 'YouTube te da piezas sueltas de un rompecabezas. Este Kit es la caja con la imagen final y las instrucciones paso a paso. Es un sistema integrado, no tips aislados.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Totalmente. Tienes 7 días. Si no aplicas el sistema y ves mejoras en la mesa, te devolvemos tu dinero por Mercado Pago.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 sm:py-16 lg:py-20 bg-navy-800 border-t border-navy-700" data-id="element-87">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="text-center mb-8 sm:mb-12" data-id="element-89">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display text-offwhite uppercase mb-2 sm:mb-4" data-id="element-90">
            DUDAS COMUNES /{' '}
            <span className="text-gold-500" data-id="element-91">PREGUNTAS FRECUENTES</span>
          </h2>
        </div>

        <div className="flex flex-col gap-2 sm:gap-3" data-id="element-92">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="bg-navy-900 border border-navy-700 rounded-xl overflow-hidden" data-id="element-93">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 py-3 sm:px-6 sm:py-5 flex items-center justify-between text-left focus:outline-none hover:bg-navy-800/50 transition-colors" data-id="element-94">
                  <span className="font-bold text-offwhite text-xs sm:text-sm md:text-base pr-2 sm:pr-4" data-id="element-95">
                    {faq.q}
                  </span>
                  {isOpen ? <MinusIcon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-400 flex-shrink-0" data-id="element-96" /> : <PlusIcon className="w-4 h-4 sm:w-5 sm:h-5 text-text-secondary flex-shrink-0" data-id="element-97" />}
                </button>

                <AnimatePresence data-id="element-98">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-99">
                      <div className="px-4 pb-4 sm:px-6 sm:pb-5 text-text-secondary text-[11px] sm:text-sm md:text-base leading-relaxed" data-id="element-100">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}